import { render, staticRenderFns } from "./Lilliput.vue?vue&type=template&id=2bf92401&"
import script from "./Lilliput.vue?vue&type=script&lang=js&"
export * from "./Lilliput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports